import { render, staticRenderFns } from "./PresenceLongTimeAlertCount.vue?vue&type=template&id=090b9ae0"
import script from "./PresenceLongTimeAlertCount.vue?vue&type=script&lang=js"
export * from "./PresenceLongTimeAlertCount.vue?vue&type=script&lang=js"
import style0 from "./PresenceLongTimeAlertCount.vue?vue&type=style&index=0&id=090b9ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports